import { z } from 'zod';
import * as dt from '../data.types.js';
import { uuidSchema, } from './primitives.js';
export const ConfigureSsoRequestSchema = z.object({
    ssoEnabled: z.boolean(),
    ssoEnforcement: z.enum(['disabled', 'optional', 'required']),
    samlIdpEntityId: z.string().min(1).optional(),
    samlIdpSsoUrl: z.string().url().optional(),
    samlIdpCertificate: z.string().min(1).optional(),
    ssoJitProvisioning: z.boolean().optional(),
    ssoDefaultRole: z.nativeEnum(dt.ALL_USER_ROLES).optional(),
    samlAttributeMapping: z.record(z.string()).optional(),
});
export const ConfigureSsoResponseSchema = z.object({
    message: z.string(),
    tenant: z.object({
        id: uuidSchema,
        name: z.string(),
        subdomain: z.string(),
        ssoEnabled: z.boolean(),
        ssoEnforcement: z.enum(['disabled', 'optional', 'required']),
        ssoConfigured: z.boolean(),
        ssoConfiguredAt: z.string().datetime().nullable().optional(),
    }),
});
export const SsoLoginRequestSchema = z.object({
    tenantId: uuidSchema,
    redirectUri: z.string().url(),
});
export const SsoLoginResponseSchema = z.object({
    loginUrl: z.string().url(),
});
export const SsoTestConnectionResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
});
export const DisableSsoResponseSchema = z.object({
    message: z.string(),
});
//# sourceMappingURL=sso.schemas.js.map